import { render } from "./DetailedProjectSkeleton.vue?vue&type=template&id=9983003e"
import script from "./DetailedProjectSkeleton.vue?vue&type=script&lang=js"
export * from "./DetailedProjectSkeleton.vue?vue&type=script&lang=js"

import "./DetailedProjectSkeleton.vue?vue&type=style&index=0&id=9983003e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__